import { DatasetId } from "@intelligems/ig-types";

export const getIncludePostPurchaseOfferBreakdown = ({
  datasetId,
  hasTestPostPurchase,
}: {
  datasetId: DatasetId;
  hasTestPostPurchase: boolean;
}): boolean | undefined => {
  if (datasetId !== "variation_products" || !hasTestPostPurchase) {
    return undefined;
  }

  return true;
};
